import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AppLayoutFacadeService} from '../app-layout-facade.service';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StaffMemberAccessRightRouteGuard  {

  constructor(private _appLayoutFacade: AppLayoutFacadeService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let roles = route.data['accessRight'];
    if (!roles) {
      throw Error('accessRight data should be set on StaffMemberAccessRightRouteGuard for route ' + route);
    }
    return this._appLayoutFacade.profileStaffMemberHasRight(roles).pipe(
      tap(result => {
        if (!result) {
          this._router.navigate(['/']);
        }
      })
    );
  }

}
